export const SET_SITE = "SET_SITE";
export const RESET = "RESET_SITE";
